"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var recharts_1 = require("recharts");
var date_fns_1 = require("date-fns");
var lodash_1 = require("lodash");
var browserUtils_1 = require("../../../../youwell-common/browserUtils");
var arrayUtils_1 = require("../../../../youwell-common/arrayUtils");
var store_1 = require("../../../../app/store");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var utils_1 = require("../utils");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        detailTable: {
            marginBottom: theme.spacing(4),
        },
        detailTableHeaderCell: {},
        chartTitle: {
            marginBottom: theme.spacing(2),
        },
        chart: (_a = {
                margin: theme.spacing(4)
            },
            _a[theme.breakpoints.down('xs')] = {
                margin: theme.spacing(2, 0),
            },
            _a),
        customTooltip: {
            backgroundColor: theme.youwell.colors.secondaryBackground,
            padding: theme.spacing(2),
            borderRadius: theme.youwell.shapes.borderRadius,
        },
        tooltipHeader: {
            textTransform: 'capitalize',
        },
        chartDescription: {
            margin: theme.spacing(2, 2, 4),
        },
    });
}, { name: 'WeekAverageDetails' });
var generateWeeklySummaryGraphData = function (sleepEntries) {
    var sleepLookup = (0, utils_1.getSleepLookup)(sleepEntries);
    var summary = sleepEntries === null || sleepEntries === void 0 ? void 0 : sleepEntries.reduce(function (prev, sleepEntry) {
        var _a;
        var weekNumber = (0, dateUtils_1.getWeekNumberFromDate)(new Date(sleepEntry.date));
        var yearWeek = "".concat(weekNumber, " - ").concat((0, date_fns_1.getYear)(new Date(sleepEntry.date)));
        var selectedWeek = { weekNo: weekNumber, start: (0, date_fns_1.startOfISOWeek)(new Date(sleepEntry.date)), end: (0, date_fns_1.endOfISOWeek)(new Date(sleepEntry.date)) };
        var selectedWeekEntries = (0, utils_1.getRegistrationsForWeek)(sleepLookup, selectedWeek);
        var currentWeekAverage = (0, utils_1.getWeekAverage)(selectedWeekEntries);
        if (currentWeekAverage.totalSleepMinutes && currentWeekAverage.sleepQuality && currentWeekAverage.sleepRating) {
            currentWeekAverage.tick = new Date(sleepEntry.date).getTime();
            currentWeekAverage.week = weekNumber;
            return __assign(__assign({}, prev), (_a = {}, _a[yearWeek] = currentWeekAverage, _a));
        }
        return prev;
    }, {});
    var sortedSummary = (0, lodash_1.sortBy)(Object.values(summary || []), 'tick');
    var graphData = sortedSummary.map(function (d) { return ({
        week: d.week,
        totalSleepMinutes: (d.totalSleepMinutes / d.count) / 60,
        sleepQuality: ((d.sleepRating / d.count) / 5) * 100,
        sleepEfficiency: d.sleepQuality / d.count,
    }); });
    return graphData;
};
var WeekAverageDetails = function (_a) {
    var weekAverage = _a.weekAverage;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var theme = (0, core_1.useTheme)();
    var sleepEntries = (0, store_1.useYouwellSelector)(function (state) { return (0, arrayUtils_1.sortByDateAscending)(state.sleepDataStore.entries, 'date') || []; });
    var width = (0, browserUtils_1.useWindowSize)().width;
    var weeklySleepSummary = generateWeeklySummaryGraphData(sleepEntries);
    var WeekAverageGraphTooltip = function (_a) {
        var _b, _c, _d, _e, _f, _g;
        var active = _a.active, payload = _a.payload;
        if (active && payload && payload.length) {
            return (React.createElement("div", { className: classes.customTooltip },
                React.createElement(core_1.Typography, { variant: "subtitle2", className: classes.tooltipHeader }, "".concat(translate('time.week'), " ").concat((_c = (_b = payload[0]) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.week)),
                React.createElement(core_1.Typography, { variant: "body2", color: "primary" }, "".concat(translate('sleepDiary.totalSleepMinutes'), ": ").concat((0, dateUtils_1.hourCount)(((_d = payload[0].payload) === null || _d === void 0 ? void 0 : _d.totalSleepMinutes) * 60, translate, true))),
                React.createElement(core_1.Typography, { variant: "body2", color: "primary" }, "".concat(translate('sleepDiary.yourSleepRating'), ": ").concat(Math.round(5 * ((_e = payload[0].payload) === null || _e === void 0 ? void 0 : _e.sleepQuality) / 10) / 10)),
                React.createElement(core_1.Typography, { variant: "body2", color: "primary" }, "".concat(translate('sleepDiary.sleepEfficiency'), ": ").concat(Math.round((_g = (_f = payload[0]) === null || _f === void 0 ? void 0 : _f.payload) === null || _g === void 0 ? void 0 : _g.sleepEfficiency), "%"))));
        }
        return null;
    };
    return (React.createElement("div", null,
        React.createElement(core_1.Table, { className: classes.detailTable },
            React.createElement(core_1.TableBody, null,
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.detailTableHeaderCell }, translate('sleepDiary.totalSleepMinutes')),
                    React.createElement(core_1.TableCell, { align: "right" }, (0, dateUtils_1.hourCount)(weekAverage.totalSleepMinutes / weekAverage.count, translate))),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.detailTableHeaderCell }, translate('sleepDiary.awakeBedMinutes')),
                    React.createElement(core_1.TableCell, { align: "right" }, (0, dateUtils_1.hourCount)(weekAverage.awakeBedMinutes / weekAverage.count, translate))),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.detailTableHeaderCell }, translate('sleepDiary.totalBedMinutes')),
                    React.createElement(core_1.TableCell, { align: "right" }, (0, dateUtils_1.hourCount)(weekAverage.totalBedMinutes / weekAverage.count, translate))),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.detailTableHeaderCell }, translate('sleepDiary.sleepQuality')),
                    React.createElement(core_1.TableCell, { align: "right" }, "".concat(Math.round(weekAverage.sleepQuality / weekAverage.count), " %"))),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.detailTableHeaderCell },
                        translate('sleepDiary.yourSleepRating'),
                        React.createElement("br", null),
                        React.createElement(core_1.Typography, { variant: "caption" }, translate('sleepDiary.sleepRatingDescription'))),
                    React.createElement(core_1.TableCell, { align: "right" }, "".concat((weekAverage.sleepRating / weekAverage.count).toFixed(1)))))),
        React.createElement(core_1.Typography, { variant: "h6", className: classes.chartTitle }, translate('sleepDiary.weeklyProgression')),
        React.createElement("div", { className: classes.chart },
            React.createElement(recharts_1.ComposedChart, { width: (width && width * 0.7) || 600, height: 300, data: weeklySleepSummary, margin: {
                    top: 5,
                    bottom: 5,
                } },
                React.createElement(recharts_1.CartesianGrid, { vertical: false }),
                React.createElement(recharts_1.XAxis, { dataKey: "week", tickFormatter: function (weekNumber) { return "".concat(translate('time.week'), " ").concat(weekNumber); }, tickMargin: 8 }),
                React.createElement(recharts_1.YAxis, { yAxisId: "left", orientation: "left", tickFormatter: function (decimal) { return "".concat(Math.round(decimal), "%"); } }),
                React.createElement(recharts_1.Tooltip, { content: React.createElement(WeekAverageGraphTooltip, null) }),
                React.createElement(recharts_1.Line, { strokeWidth: 4, stroke: theme.youwell.colors.primary, dot: { fill: theme.youwell.colors.primary, r: 5 }, yAxisId: "left", type: "monotone", dataKey: "sleepEfficiency", name: translate('sleepDiary.sleepQuality') }),
                React.createElement(recharts_1.Legend, { verticalAlign: "top", wrapperStyle: { top: -20 } }))),
        React.createElement(core_1.Typography, { variant: "body2", color: "textSecondary", className: classes.chartDescription }, translate('sleepDiary.hooverToSeeDetails'))));
};
exports.default = WeekAverageDetails;
